const defaultFormInputAttributes = {
  optional: ["enum", { values: ["yes", "no"] }],
  label: "string",
  csvColumnName: "string",
};

export default defaultFormInputAttributes;
